<style lang="sass" scoped>
  @import '../../../sass/variables'

  #current-scenario
    font-size: 1.5rem
    font-weight: 500
    line-height: 130%
    color: $salesflow-font-gray

    b
      font-weight: 700


  .dashboard
    margin-bottom: 2rem
    padding-top: 8px

    h2
      font-size: 1.75rem
      font-weight: 500
      line-height: 130%
      margin-bottom: 0

  ::v-deep
    .hidden
      opacity: 0

    .disabled
      pointer-events: none
      opacity: 0.3

    .circle-purple-checkbox .custom-control-label
      color: #fff

    .card
      overflow: hidden
      background: $salesflow-bg-content
      box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1)
      border-radius: 24px
      &.card-table
        .card-header
          padding-bottom: 0

        .card-body
          padding-top: 10px

          .table
            margin-bottom: 0

            tr:first-child
              td
                border: 0

      .card-header
        background-color: transparent

      .card-body
        .loader
          position: absolute
          top: 50%
          left: 50%
          margin-top: -30px
          margin-left: -30px
          width: 60px
          height: 60px

        .fake
          opacity: 0.9

          &.hovering // Lower opacity and no pointer events when hovering
            pointer-events: none
            opacity: 0.1

      h2
        font-weight: 700
        font-size: 1.5rem
        color: $salesflow-font-gray
        line-height: 120%

      small, .small
        font-size: 0.5rem

        a
          color: $black !important
</style>

<template>
  <div class="dashboard">
    <div class="row bdk-pl-8 bdk-pr-8">
      <div class="col-12 p-0">
        <h1 class="page-title">
          DASHBOARD
        </h1>
      </div>
    </div>
    <div class="row bdk-pl-8 bdk-pr-8">
      <div class="col-12 p-0 d-flex align-items-center justify-content-between">
        <h2 class="page-subtitle">
          {{ __('Olá') }} <b>{{ user.name | firstword }}</b>, {{ __('suas análises estão definidas') }}
        </h2>
        <div class="ml-3">
          <InputDaterange
            name="range"
            custom-class="m-t-5"
            theme="modern"
            :start="14"
            :width="100"
            :placeholder="__('Últimos 15 dias')"
            :min-date="minDate"
            v-model="range"
            position="left"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <DashboardFunnelWidget
          :user="user"
          :range="range"
          :imports="imports"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <GeneralStatsWidget
          :user="user"
          :range="range"
          :imports="imports"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <LeadOriginWidget
          :user="user"
          :range="range"
          :imports="imports"
        />
      </div>
    </div>
    <div class="row mt-40px">
      <div class="col-12">
        <h2 id="current-scenario"><b>{{ user.name | firstword }}</b>{{ __(', este é seu cenário atual') }}</h2>
      </div>
    </div>
    <div class="row mt-4 mb-5">
      <div class="col-7">
        <PipelineWidget :user="user" />
      </div>
      <div class="col-5">
        <UserClosesWidget
          :user="user"
          :range="range"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4">
        <ActivityWidget
          :user="user"
          :range="range"
        />
      </div>
      <div class="col-4">
        <MailStatsWidget
          :user="user"
          :range="range"
          :imports="imports"
        />
      </div>
      <div class="col-4">
        <LeadStatsWidget :user="user" />
      </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';
import LeadOriginWidget from './LeadOriginWidget.vue';
import GeneralStatsWidget from './GeneralStatsWidget.vue';
import PipelineWidget from './PipelineWidget.vue';
import LeadStatsWidget from './LeadStatsWidget.vue';
import ActivityWidget from './ActivityWidget.vue';
import MailStatsWidget from './MailStatsWidget.vue';
import UserClosesWidget from './UserClosesWidget.vue';
import dayjs from '../../core/dayjs';

export default {
  components: {
    BFormCheckbox,
    GeneralStatsWidget,
    LeadOriginWidget,
    PipelineWidget,
    LeadStatsWidget,
    MailStatsWidget,
    UserClosesWidget,
    ActivityWidget,
  },

  props: ['user'],

  data () {
    return {
      range: null,
      imports: true,
      minDate: dayjs().subtract(179, 'days').toDate(),
    };
  },
};
</script>
